const SITE_URL: string = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env && ((import.meta as Record<string, Record<string, string>>).env.VITE_SITE_URL)) || '';

export function getSiteUrl(path: string): string {
  return `${SITE_URL}${path}`;
}

export const SITE_NAME = 'Superbuy Sheet Hub';
export const SITE_DESCRIPTION = 'The ultimate Superbuy Spreadsheet resource hub. Find updated spreadsheet collections, product guides, QC tips, and expert resources for smart shopping.';
export const SITE_LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png';

export interface FAQItem {
  question: string;
  answer: string;
}

export function generateWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: getSiteUrl('/'),
    description: SITE_DESCRIPTION,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${getSiteUrl('/')}?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: getSiteUrl('/'),
    logo: SITE_LOGO_URL,
    description: SITE_DESCRIPTION,
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };
}

export function generateArticleSchema(params: {
  path: string;
  headline: string;
  description: string;
  datePublished: string;
  dateModified: string;
  imageUrl?: string;
  authorName?: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: params.headline,
    description: params.description,
    url: getSiteUrl(params.path),
    datePublished: params.datePublished,
    dateModified: params.dateModified,
    author: {
      '@type': 'Organization',
      name: params.authorName || 'Superbuy Sheet Editorial Team',
      url: getSiteUrl('/'),
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: SITE_LOGO_URL,
      },
    },
    ...(params.imageUrl ? { image: params.imageUrl } : {}),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': getSiteUrl(params.path),
    },
  };
}

export function generateBreadcrumbListSchema(items: Array<{ name: string; path: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: getSiteUrl(item.path),
    })),
  };
}

export function generateFAQPageSchema(faqs: FAQItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}